import { Market } from '../../types';
import { ApiInstance } from '../instance';

export type MarketPayload = {
  campaign_id: string;
  name: string;
  parent_bid: string;
  subtype_bids: any;
  targeting: any;
  call_hours?: string | null;
  status?: 'active' | 'paused' | 'archived' | 'pending';
};

export const MarketController = {
  getMarkets: async (payload: { campaign_id: string }) => {
    return await ApiInstance.post(`/advertisers/markets`, payload);
  },
  getMarket: async (payload: { id: string }) => {
    return await ApiInstance.get(`/advertisers/markets/${payload.id}`);
  },
  createMarket: async (payload: MarketPayload) => {
    return await ApiInstance.post(`/advertisers/markets/create`, payload);
  },
  updateMarket: async (payload: { market_id: string, updated_data?: Partial<Market> }) => {
    return await ApiInstance.post(`/advertisers/markets/update`, payload);
  },
};
